import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const initialValue = {};
const CrmMessagingContext = /*#__PURE__*/createContext(initialValue);
export function useCrmMessagingContext() {
  return useContext(CrmMessagingContext);
}
export function CrmMessagingProvider({
  messagingId,
  children
}) {
  const contextValue = useMemo(() => ({
    messagingId
  }), [messagingId]);
  return /*#__PURE__*/_jsx(CrmMessagingContext.Provider, {
    value: contextValue,
    children: children
  });
}